import Button from '@/components/NextUI/Button';
import SvgCheck from '@/components/Common/Icons/Check';
import { useTranslations } from 'next-intl';

export const FinalStep = ({ handleClose }: { handleClose: () => void }) => {
  const t = useTranslations('modals.cancel_subscription.steps.final');

  return (
    <>
      <div>
        <span className="text-xl font-semibold text-dark">{t('title')}</span>
        <p className="text-gray-medium text-[17px] mt-6">{t('description')}</p>
      </div>
      <div className="w-full h-full flex items-center justify-center mt-8">
        <SvgCheck width={187} height={144} />
      </div>
      <div className="flex justify-end mt-12 w-full">
        <Button onClick={handleClose}>{t('button')}</Button>
      </div>
    </>
  );
};
